import PropTypes from "prop-types";

/* ProgressBarSlider */

export const ProgressBarSliderStylesProps = {
  alwaysShowHandle: PropTypes.bool,
};

// Do not rename value & onChange, otherwise <ProgressBarSlider>
// will not work inside AntDesign <Form.Item>
export const ProgressBarSliderProps = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  onChange: PropTypes.func,
  ...ProgressBarSliderStylesProps,
};

/* ProgressBar */

export const ProgressBarStylesProps = {
  withBorder: PropTypes.bool,
  style: PropTypes.object,
  ...ProgressBarSliderStylesProps,
};

export const ProgressBarProps = {
  ...ProgressBarSliderProps,
  ...ProgressBarStylesProps,
  isEditable: PropTypes.bool,
};
